import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  insuredRisks: [],
  insuredRisksStatus: IDLE
};

const insuredRisksSlice = createSlice({
  name: 'insuredRisks',
  initialState,
  reducers: {
    getInsuredRisks: (state) => {
      state.insuredRisksStatus = LOADING;
    },
    getInsuredRisksSucceeded: (state, action) => {
      state.insuredRisksStatus = SUCCEEDED;
      state.insuredRisks = action.payload;
    },
    getInsuredRisksFailed: (state) => {
      state.insuredRisksStatus = FAILED;
    }
  }
});

export const { getInsuredRisks, getInsuredRisksSucceeded, getInsuredRisksFailed } = insuredRisksSlice.actions;

export default insuredRisksSlice.reducer;
